export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
}